// SweetAlert2 con los colores de la marca (antes cada Swal.fire usaba los morado/gris por
// default de la librería, o colores sueltos distintos según el archivo — hallazgo UX-08 de
// la ronda 6 de QA). Usar estos en vez de `import Swal from 'sweetalert2'` directo.
import SwalBase from 'sweetalert2';

const Swal = SwalBase.mixin({
  confirmButtonColor: '#14A7A3',
  cancelButtonColor: '#6c757d',
});

/** Confirmación de una acción destructiva (eliminar, cancelar): botón de confirmar en rojo. */
export const confirmarEliminar = (opciones = {}) =>
  Swal.fire({
    title: '¿Estás seguro?',
    text: '¡No podrás revertir esto!',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Sí, eliminar',
    cancelButtonText: 'Cancelar',
    ...opciones,
    confirmButtonColor: '#d32f2f',
  });

/**
 * Avisos unificados (propuesta aprobada por Alex el 2026-10-16, ver
 * docs/qa-cowork/propuesta-avisos-unificados.md): antes cada pantalla titulaba sus avisos de
 * éxito distinto ("¡Listo!", "Actualización exitosa", "Aviso!") y con tres botones parecidos
 * en la pestaña Comentarios la terapeuta no sabía qué acción acababa de ejecutar. Usar estas
 * tres en vez de armar el Swal.fire a mano.
 */

/** Éxito: se cierra solo, sin botón — no interrumpe el flujo de quien ya completó la acción. */
export const avisoExito = (msg) =>
  Swal.fire({
    title: '¡Listo!',
    text: msg,
    icon: 'success',
    timer: 2500,
    showConfirmButton: false,
  });

/** Falta algo para completar la acción (p. ej. encuesta sociodemográfica incompleta). */
export const avisoFalta = (msg) =>
  Swal.fire({
    title: 'Falta información',
    text: msg,
    icon: 'warning',
    confirmButtonText: 'Entendido',
  });

/** Error real (de red, del servidor): el mensaje debe ir en lenguaje llano, nunca el texto técnico. */
export const avisoError = (msg) =>
  Swal.fire({
    title: 'No se pudo completar',
    text: msg,
    icon: 'error',
    confirmButtonText: 'Entendido',
  });

export default Swal;
